import { render, staticRenderFns } from "./purchaseReturnNoticesList.vue?vue&type=template&id=c745345a&scoped=true"
import script from "./purchaseReturnNoticesList.vue?vue&type=script&lang=js"
export * from "./purchaseReturnNoticesList.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnNoticesList.vue?vue&type=style&index=0&id=c745345a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c745345a",
  null
  
)

export default component.exports